export const SET_DATA = 'SET_DATA'
export const GET_DATA = 'GET_DATA'
